module.exports = __webpack_public_path__ + "static/img/sj_t@2x.c4612db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/sj_t@2x.png
// module id = Bz/8
// module chunks = 1